import RadioGroup from "../form/grouped/radio/radio-group";
import { Payment_Method } from "../../utils/shared-radio";
import { useState, useCallback } from "react";
import { P2TextDescription, P2TextLabel } from "react-bootstrap-common-script";

interface PaymentProps {
  PaymentHandler?: (value: string) => void;
}

const PaymentMethod = ({ PaymentHandler }: PaymentProps) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string>("");
  const handlePaymentHandler = useCallback((value: string) => {
    setSelectedPaymentMethod(value);
    PaymentHandler?.(value);
  },[PaymentHandler]);
  
  return (
    <div className="polymer-payment-method-container">
      <div className="polymer-payment-method-container-content">
        <p className="polymer-payment-method-container-content__title">Mode of payment:</p>      
        <p className="polymer-payment-method-container-content__description">Credit/ debit card</p>      
      </div>
      {/* <RadioGroup
        required={false}
        label="Select mode of payment"
        layout="default"
        items={Payment_Method}
        value={selectedPaymentMethod} // Pass the selectedPaymentMethod state to RadioGroup
        onItemSelect={handlePaymentHandler} // Pass the local handler to update the state
      /> */}
    </div>
  );
};

export default PaymentMethod;
